import { Text } from "@sfc/ui";

/** Show stored instants in the applicant's timezone, including its zone name. */
export function ApplicationDeadline({
  opensAt,
  closesAt,
}: {
  opensAt?: string | null;
  closesAt?: string | null;
}) {
  return (
    <>
      {[
        { label: "Scheduled opening", instant: opensAt },
        { label: "Edits and submissions close", instant: closesAt },
      ].map(({ label, instant }) =>
        instant ? (
          <Text variant="body-sm" tone="muted-foreground" key={label}>
            {label}{" "}
            <time dateTime={instant}>
              {new Date(instant).toLocaleString(undefined, {
                year: "numeric",
                month: "short",
                day: "numeric",
                hour: "numeric",
                minute: "2-digit",
                timeZoneName: "short",
              })}
            </time>
            .
          </Text>
        ) : null,
      )}
    </>
  );
}
